
var FormBuilder = function()
{

	var editContainer = $('[data-javascript="edit-form"]');
	var createContainer = $('[data-javascript="create-form"]');


	/**
	 * [blurSlugify description]
	 * @param  {[type]} text [description]
	 * @return {[type]}      [description]
	 */
	var blurSlugify = function( text )
	{
		return text
			.replace(/^_+/, '')		// Trim - from start of text
			.replace(/_+$/, '');		// Trim - from end of text
	};

	/**
	 * [AddElement description]
	 */
	var AddElement = function()
	{

		/**
		 * [whenAddElementVisible description]
		 * @param  {[type]} modalObj [description]
		 * @return {[type]}          [description]
		 */
		var whenAddElementVisible = function( modalObj )
		{
			var options = $('[name="options"]');
			$('[name="element_id"]').change(function(){
				options.prop( 'disabled', true );
				if( $.inArray( parseInt( $(this).val() ), [ 3, 4, 5] ) !== -1 ) {
					options.prop( 'disabled', false );
				}
			}).trigger('change');
			$('[name="element_name"]')
			.unbind( 'keyup' ).bind( 'keyup', function(e) {
				if( $.inArray( parseInt( e.which ), [37, 39, 8] ) !== -1 ) return;
				$(this).val( $.fn.ensphere.veto.slugify( $(this).val() ) );
			})
			.unbind( 'blur' ).bind( 'blur', function(e){
				$(this).val( blurSlugify( $(this).val() ) );
			});
		};

		/**
		 * [updateElementsTable description]
		 * @param  {[type]} response   [description]
		 * @param  {[type]} attributes [description]
		 * @param  {[type]} modal      [description]
		 * @return {[type]}            [description]
		 */
		var updateElementsTable = function( response, attributes, modal )
		{
			$('elements').html( response.view );
			bindEvents();
			if( modal ) modal.semanticUiModal( 'hide' );
		};

		/**
		 * [addElementHandler description]
		 * @param {[type]} e [description]
		 */
		var addElementHandler = function( e ) {
			e.preventDefault();
			$.fn.ensphere.veto.modalEdit( this, {
				onVisible : whenAddElementVisible,
				onComplete : updateElementsTable
			});
		};

		/**
		 * [whenEditElementVisible description]
		 * @param  {[type]} modalObj [description]
		 * @return {[type]}          [description]
		 */
		var whenEditElementVisible = function( modalObj )
		{
			whenAddElementVisible( modalObj );
		};

		/**
		 * [editElementHandler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var editElementHandler = function( e ) {
			e.preventDefault();
			$.fn.ensphere.veto.modalEdit( this, {
				onVisible : whenEditElementVisible,
				onComplete : updateElementsTable
			});
		};

		/**
		 * [deleteElementHandler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var deleteElementHandler = function( e ) {
			e.preventDefault();
			var button = $(this);
			$.get( button.attr( 'href' ), function( response ) {
				button.parents('tr:eq(0)').fadeOut( 200, function(){
					$(this).remove();
					updateElementsTable(response);
				});
			});
		};

		/**
		 * [sorter description]
		 * @return {[type]} [description]
		 */
		var sorter = function(){
			//$('.sort-table').rowSorter('destroy');
			$('.sort-table').rowSorter({
				handler: ".handle",
				onDrop: function( tbody, row, new_index, old_index ) {
					var table = $(tbody.tagName.toLowerCase() === "tbody" ? tbody.parentNode : tbody);
					var ids = [];
					$('tbody tr', table).each(function(){
						ids.push( $(this).attr('data-field-id') );
					});
					$.ajaxSetup({ headers: { 'X-CSRF-TOKEN': $('[name="_token"]').val() } });
					$.post( $('#sort_url').val(), { orders : ids } );
				}
			});
		};

		/**
		 * [bindEvents description]
		 * @return {[type]} [description]
		 */
		var bindEvents = function()
		{
			$('[data-for="adding-element"]').unbind( 'click' ).bind( 'click', addElementHandler );
			$('[data-for="editing-element"]').unbind( 'click' ).bind( 'click', editElementHandler );
			$('[data-for="deleting-element"]').unbind( 'click' ).bind( 'click', deleteElementHandler );
			sorter();
		};

		bindEvents();
	};

	var CreateForm = function()
	{

		$.fn.ensphere.veto.wysiwyg( '.redactor' );
	};


	/**
	 * [init description]
	 * @return {[type]} [description]
	 */
	this.init = function()
	{
		if( editContainer.length ) {
			new AddElement();
		}
		if( createContainer.length ) {
			new CreateForm();
		}
		var types = $('[data-for="submission-type"]');
		if( types.length ) {
			types.on( 'change', function(){
				$.get( window.submission_type_url, { submission_type : $(this).val(), submission: $(this).attr( 'data-submission' ) } );
			});
		}
	};

	return this;

};

jQuery(document).ready( function($){

	new FormBuilder().init();

});
